<div class="loader-wrapper brand-partner-list-wrapper">
  <section>
    <div class="partner-list-wrapper">
      <div class="header" *ngIf="dataSource">
        <div>
          <span class="partner-count"
            >{{ dataSource.data.length }}
            {{ "dashboard.partners.title" | translate }}
          </span>
          <a
            class="button-transparent show-partner-status-chart"
            (click)="showPartnerStatusChart()"
          >
            <mat-icon
              class="mat-icon material-icons"
              role="img"
              aria-hidden="true"
              >bar_chart</mat-icon
            >
            <span>{{ "brand.campaign.partners.viewStats" | translate }}</span>
          </a>
        </div>
        <div>
          <div class="column-filter" (clickOutside)="showColumnFilters = false">
            <div
              (click)="showColumnFilters = !showColumnFilters"
              class="button-wrapper"
            >
              <p>{{ "brand.campaign.partners.displayColumns" | translate }}</p>
              <div class="arrow-down"></div>
            </div>
            <ul [ngClass]="{ visible: showColumnFilters }">
              <ng-container
                *ngFor="let column of displayedColumns; let i = index"
              >
                <li *ngIf="i !== 0 && i !== displayedColumns.length - 1">
                  <mat-checkbox
                    name="display{{ column }}"
                    [checked]="column.visible"
                    (change)="toggleColumn(column)"
                    >{{ "dashboard.partner." + column.value | translate }}
                  </mat-checkbox>
                </li>
              </ng-container>
            </ul>
          </div>
          <div class="column-export" (clickOutside)="showExportOptions = false">
            <div
              (click)="showExportOptions = !showExportOptions"
              class="button-wrapper"
            >
              <p>{{ "brand.campaign.partners.export" | translate }}</p>
              <div class="arrow-down"></div>
            </div>
            <ul [ngClass]="{ visible: showExportOptions }">
              <li>
                <a (click)="exportPartners('CSV')" class="button-link">
                  {{ "brand.campaign.partners.csv" | translate }}
                </a>
              </li>
              <li>
                <a (click)="exportPartners('XLS95')" class="button-link">
                  {{ "brand.campaign.partners.excel95" | translate }}
                </a>
              </li>
              <li>
                <a (click)="exportPartners('XLS2007')" class="button-link">
                  {{ "brand.campaign.partners.excel07" | translate }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="table-pagination-wrapper">
        <div class="table-wrapper">
          <mat-table #table [dataSource]="dataSource" matSort>
            <!--Column Definition: -->
            <ng-container
              *ngFor="let column of getVisibleColumnKeys(); let index = index"
              matColumnDef="{{ column }}"
              [sticky]="index === 0"
              [stickyEnd]="index === getVisibleColumnKeys().length - 1"
            >
              <!-- Partner fields columns  -->
              <ng-container *ngIf="index !== getVisibleColumnKeys().length - 1">
                <mat-header-cell mat-header-cell *matHeaderCellDef>
                  <div class="header-title-wrapper" mat-sort-header>
                    {{ "dashboard.partner." + column | translate }}
                    {{ getColumnSum(column) }}
                    <mat-icon
                      (click)="showPartnerStatusChart()"
                      class="info"
                      *ngIf="column === 'status'"
                      >info
                    </mat-icon>
                  </div>
                  <div class="search-header-wrapper">
                    <form
                      class="search-field"
                      *ngIf="index !== getVisibleColumnKeys().length - 1"
                    >
                      <mat-form-field class="no-hint">
                        <mat-label>{{
                          "brand.campaign.partners.searchPlaceholder"
                            | translate
                        }}</mat-label>
                        <input
                          matInput
                          [(ngModel)]="filters[column]"
                          name="{{ column }}-filter"
                          (keyup)="applyFilter()"
                        />
                      </mat-form-field>
                    </form>
                  </div>
                </mat-header-cell>
                <mat-cell
                  [ngClass]="getCellClass(row[column], column)"
                  *matCellDef="let row"
                  [innerHTML]="formatData(row[column], column) | translate"
                />
              </ng-container>

              <!-- Last column for "actions" -->
              <ng-container *ngIf="index === getVisibleColumnKeys().length - 1">
                <mat-header-cell *matHeaderCellDef>
                  <div class="header-title-wrapper">
                    {{ "brand.campaign.partners.actions" | translate }}
                  </div>
                  <div class="search-header-wrapper">&nbsp;</div>
                </mat-header-cell>
                <mat-cell *matCellDef="let partner">
                  <div class="actions">
                    <div
                      class="row-action"
                      *ngIf="partnerCanBeAccepted(partner)"
                    >
                      <img
                        (click)="onAcceptPartner(partner)"
                        title="{{ 'shared.approve' | translate }}"
                        class="row-action-icon"
                        src="/assets/images/icons/ic_brand_partner_verify.svg"
                      />
                    </div>
                    <div
                      class="row-action"
                      *ngIf="partnerCanBeCancelled(partner)"
                    >
                      <img
                        (click)="onCancelPartner(partner)"
                        title="{{ 'shared.cancel' | translate }}"
                        class="row-action-icon"
                        src="/assets/images/icons/ic_brand_partner_cancel.svg"
                      />
                    </div>
                    <div class="row-action">
                      <img
                        (click)="openBrandNotesDialog(partner)"
                        title="{{
                          'brand.campaign.partnerList.partnerNotes' | translate
                        }}"
                        class="row-action-icon"
                        src="/assets/images/icons/ic_brand_partner_note.svg"
                      />
                    </div>
                  </div>
                </mat-cell>
              </ng-container>
            </ng-container>
            <tr
              mat-header-row
              *matHeaderRowDef="getVisibleColumnKeys()"
              class="first-header-row"
            ></tr>
            <mat-row *matRowDef="let row; columns: getVisibleColumnKeys()" />
          </mat-table>
        </div>
        <div class="table-pagination-footer">
          <mat-paginator fixed [pageSizeOptions]="[10]" showFirstLastButtons />
        </div>
      </div>
    </div>
  </section>
  <app-loader
    [text]="'shared.loadingCampaign' | translate"
    [ngClass]="{ visible: loading }"
  />
</div>
